import { render } from "./terms_and_conditions.vue?vue&type=template&id=0d63ffb8"
import script from "./terms_and_conditions.vue?vue&type=script&lang=js"
export * from "./terms_and_conditions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__